import React from 'react';
import { purify } from '../../lib/purify';

type SafeHtmlProps = {
  html: string;
  className?: string;
};

export function SafeHtml({ html, className }: SafeHtmlProps) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: purify(html.replace(/\\n/g, '<br />')),
      }}
    />
  );
}
